import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { useMobileFooterContainer } from '@/app/shell/NavLayout';

export type IncidentListLayoutBoxProps = {
  bannersArea: ReactNode;
  incidentListArea: ReactNode;
  actionBarArea: ReactNode;
  mapArea: ReactNode;
};

export function IncidentListLayoutBox({
  bannersArea,
  incidentListArea,
  actionBarArea,
  mapArea,
}: IncidentListLayoutBoxProps) {
  const mobileFooterContainer = useMobileFooterContainer();

  return (
    <>
      <div className="incident-list-layout-box">
        <div className="incident-list-layout-box__banners">{bannersArea}</div>

        <div className="incident-list-layout-box__list">{incidentListArea}</div>

        <div className="incident-list-layout-box__action-bar">{actionBarArea}</div>

        <div className="incident-list-layout-box__map">{mapArea}</div>
      </div>

      {mobileFooterContainer !== null &&
        createPortal(
          <div className="incident-list-layout-box__mobile-action-bar">{actionBarArea}</div>,
          mobileFooterContainer,
        )}
    </>
  );
}
